import { StatusEnum } from '@/app/utils/status'
import { reportApi } from '../http/httpClient'

export interface ReportTransaction {
  contract: string
  client: string
  cpf: string
  phone: string
  bithDate: string
  seller: string
  commission: number
  value: number
  table: string
  status: StatusEnum
  atividade: string
  createdAt: string
  updatedAt: string
  type: string
  team?: string
  manager?: string
  supervisor?: string
  leader?: string
  leaderCommission?: number
  commissionList?: [
    {
      name: string
      value: number
      type: string
    },
  ]

  // Apenas para ADMIN/SUPER_ADMIN; null quando não há histórico.
  // Valores em centavos (Salvcar: valor fixo, sem percentual).
  total_commission_percent?: number | null
  total_commission_value?: number | null
  admin_commission_percent?: number | null
  admin_commission_value?: number | null
}

export interface ReportTransactionResponse {
  transactions: ReportTransaction[]
  pagination: {
    skip: number
    limit: number
    sort: string
    total: number
  }
}

export interface ReportTransactionParams {
  sellerIds?: string
  supervisorIds?: string
  managerIds?: string
  leaderIds?: string
  status?: StatusEnum
  customerIds?: string
  teamIds?: string
  tableIds?: string
  startDate?: string
  endDate?: string
  maxValue?: string
  minValue?: string
  minComission?: string
  maxComission?: string
  search?: string
  limit?: number
  skip?: number
  sort?: string
}

export async function reportTransaction(
  params?: ReportTransactionParams | undefined,
) {
  const { data } = await reportApi.get<ReportTransactionResponse>(
    '/report/transactions',
    {
      params,
    },
  )

  return data
}
